<h1 mat-dialog-title>Nieznany status opłacenia</h1>
<mat-dialog-content>
  <div fxLayout="column" fxLayoutGap="16px">
    <div *ngIf="liabilities && liabilities.length === 1">
      Dodając opłatę do koszyka potwierdzasz, że nie została ona wcześniej uregulowana.
    </div>
    <div *ngIf="liabilities && liabilities.length > 1">
      Dodając opłaty do koszyka potwierdzasz, że nie zostały one wcześniej uregulowane.
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button mat-raised-button color="accent" [matDialogClose]="true">Dodaj do koszyka</button>
  <button mat-button matDialogClose>Anuluj</button>
</mat-dialog-actions>
